// ============================================================================
// RECOVERY OFFICER DASHBOARD ENDPOINTS — Phase 8.D
// ============================================================================
// Backend: RecoveryDashboardController → /api/v1/RecoveryDashboard.

import { buildEndpoint, buildEndpointWithQuery } from './base.endpoints';

export const RECOVERY_DASHBOARD_BASE_PATH = '/RecoveryDashboard';

export const recoveryDashboardEndpoints = {
  myWorkload: () => buildEndpoint(`${RECOVERY_DASHBOARD_BASE_PATH}/my-workload`),
  unclaimedQueue: (limit?: number) =>
    buildEndpointWithQuery(`${RECOVERY_DASHBOARD_BASE_PATH}/unclaimed-queue`,
      limit !== undefined ? { limit } : {}),
  actionToday: (limit?: number) =>
    buildEndpointWithQuery(`${RECOVERY_DASHBOARD_BASE_PATH}/action-today`,
      limit !== undefined ? { limit } : {}),
  recentClosures: (days?: number, limit?: number) =>
    buildEndpointWithQuery(`${RECOVERY_DASHBOARD_BASE_PATH}/recent-closures`,
      {
        ...(days !== undefined ? { days } : {}),
        ...(limit !== undefined ? { limit } : {}),
      }),
} as const;

export default recoveryDashboardEndpoints;
